import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { FormFieldModel } from './form-field.model';

export class ImageSettingsFieldModel implements FormFieldModel {
    property: string;
    fieldComponent?: Type<AbstractFormFieldComponent>;
    label?: string;
    description?: string;
    enableTooltip?: boolean = true;
    enableAltText?: boolean = true;
    enableDisplaySize?: boolean = true;
    enableInsertUrl?: boolean = true;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        enableTooltip?: boolean,
        enableAltText?: boolean,
        enableDisplaySize?: boolean,
        enableInsertUrl?: boolean
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        if (enableTooltip !== undefined && enableTooltip !== null) {
            this.enableTooltip = enableTooltip;
        }
        if (enableAltText !== undefined && enableAltText !== null) {
            this.enableAltText = enableAltText;
        }
        if (enableDisplaySize !== undefined && enableDisplaySize !== null) {
            this.enableDisplaySize = enableDisplaySize;
        }
        if (enableInsertUrl !== undefined && enableInsertUrl !== null) {
            this.enableInsertUrl = enableInsertUrl;
        }
    }
}
